var _circle, _path, _path2, _rect, _rect2, _rect3, _path3, _rect4, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescriptionListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 17,
    fill: "#FCE6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07927 10.425V5.475C7.07927 4.13431 6.23449 3 4.53671 3C3.22981 3 2 4.08414 2 5.42483L2 7.69655C2 9.6 1.99005 10.425 3.83747 10.425C4.61193 10.425 5.29887 10.425 7.07927 10.425Z",
    fill: "#276CA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6926 3H4.56347C4.55578 3 4.54809 3 4.53271 3C5.76299 3.01556 7.07938 4.08133 7.07938 5.3338V33.525C7.07938 34.8164 7.92826 36 9.20467 36H27.6926C28.969 36 29.9993 34.8164 29.9993 33.525V5.3338C29.9993 4.04243 28.969 3 27.6926 3Z",
    fill: "#4DAADD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1768,
    y: 8.77539,
    width: 13.5822,
    height: 1.65,
    rx: 0.825,
    fill: "#99DDF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1768,
    y: 12.0747,
    width: 13.5822,
    height: 1.65,
    rx: 0.825,
    fill: "#99DDF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7231,
    y: 15.375,
    width: 8.48887,
    height: 1.65,
    rx: 0.825,
    fill: "#99DDF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 35C26.9101 35 24 32.0898 24 28.5C24 24.9101 26.9101 22 30.5 22C34.0899 22 37 24.9101 37 28.5C37 32.0899 34.0899 35 30.5 35Z",
    fill: "#E57200"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.728,
    y: 23.6216,
    width: 1.625,
    height: 12.8925,
    transform: "rotate(45 34.728 23.6216)",
    fill: "#FF9E3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0135 20.6006C22.1254 18.612 24.5882 17.9307 26.5141 19.0788C28.4401 20.2269 29.1 22.7696 27.988 24.7581L23.1559 33.3994C22.044 35.388 19.5812 36.0693 17.6553 34.9212C15.7293 33.7731 15.0695 31.2304 16.1814 29.2419L21.0135 20.6006Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.572 29.0788L27.988 24.7581C29.1 22.7696 28.4401 20.2269 26.5141 19.0788C24.5882 17.9307 22.1254 18.612 21.0135 20.6006L18.5974 24.9212L25.572 29.0788Z",
    fill: "#FF9E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionListIcon);
export default __webpack_public_path__ + "static/media/PrescriptionListIcon.affae6ce657a2feb6548549bb3af59be.svg";
export { ForwardRef as ReactComponent };